// apps/web/src/api/services/subscriptions.service.ts
import { HttpClient } from '../http-client';
import {
  ApiResponse,
  SubscriptionType,
  SubscriptionTypeListResponse,
  ActiveSubscriptionInfo,
  ActiveSubscriptionsResponse,
  SubscriptionResponse,
  CreateSubscriptionRequest,
} from '@gym-management/shared';
import { AxiosResponse } from 'axios';

export class SubscriptionsService extends HttpClient {
  // Получить все активные типы абонементов
  async getSubscriptionTypes(): Promise<SubscriptionType[]> {
    const response: AxiosResponse<ApiResponse<SubscriptionTypeListResponse>> =
      await this.get('/api/subscription-types');
    if (response.data.success && response.data.data) {
      return response.data.data.types;
    }
    throw new Error(response.data.message || 'Failed to fetch subscription types');
  }

  // Получить все активные подписки (для массовой проверки)
  async getAllActiveSubscriptions(): Promise<ActiveSubscriptionInfo[]> {
    const response: AxiosResponse<ApiResponse<ActiveSubscriptionsResponse>> = await this.get(
      '/api/subscriptions/active'
    );
    if (response.data.success && response.data.data) {
      return response.data.data.subscriptions;
    }
    throw new Error(response.data.message || 'Failed to fetch active subscriptions');
  }

  // Получить подписку по ID (если нужно)
  async getSubscription(id: string): Promise<SubscriptionResponse> {
    const response: AxiosResponse<ApiResponse<SubscriptionResponse>> = await this.get(
      `/api/subscriptions/${id}`
    );
    if (response.data.success && response.data.data) {
      return response.data.data;
    }
    throw new Error(response.data.message || 'Failed to fetch subscription');
  }

  // Создать подписку (используется при создании посетителя с абонементом)
  async createSubscription(data: CreateSubscriptionRequest): Promise<SubscriptionResponse> {
    const response: AxiosResponse<ApiResponse<SubscriptionResponse>> = await this.post(
      '/api/subscriptions',
      data
    );
    if (response.data.success && response.data.data) {
      return response.data.data;
    }
    throw new Error(response.data.message || 'Failed to create subscription');
  }

  // ✅ НОВЫЙ МЕТОД: продление / обновление подписки с учётом остатка
  async renewSubscription(data: {
    visitorId: string;
    newSubscriptionTypeId: string;
    action: 'extend' | 'upgrade';
  }): Promise<ActiveSubscriptionInfo> {
    const response: AxiosResponse<ApiResponse<{ subscription: ActiveSubscriptionInfo }>> =
      await this.post('/api/subscriptions/renew', data);
    if (response.data.success && response.data.data) {
      return response.data.data.subscription;
    }
    throw new Error(response.data.message || 'Failed to renew subscription');
  }
}
